<template>
    <a class="m-btn" :class="'m-btn--'+type">
        <slot></slot>
    </a>
</template>

<script>
export default {
  name: 'Btn',
  props: {
    type: String
  }
}
</script>

<style scoped lang="scss">
.m-btn {
    position: relative;
    height: 50px;
    letter-spacing: 1.2px;
    transition: 0.4s map-get($ease, 'IOquad');
    line-height: 50px;
    text-align: center;
    width: 180px;
    border-radius: 25px;
    box-shadow: 0 3px 6px rgba($color-primary ,0.2);
    &--green {
        background: $color-secondary;
        border: 1px solid $color-secondary;
        color: $white;
    }
    &--white {
        background: $white;
        border: 1px solid $white;
        color: $color-primary;
    }
    &--fb{
        background: #3B5998;
        border: 1px solid #3B5998;
        color: $white;
    }
    &._disable{
        pointer-events: none;
    }
    @include respond-to(md) {
        &--green {
            &:hover {
                background: $white;
                border: 1px solid $white;
                color: $color-primary;
            }
        }
        &--white {
            &:hover {
                background: $color-secondary;
                border: 1px solid $color-secondary;
                color: $white;
            }
        }
        &--fb{
            &:hover {
                background: $white;
                border: 1px solid $white;
                color: #3B5998;
            }
        }
    }
}

</style>
